import { fetchAssessmentResponces } from "../actions/questionAnswer.action";
import { BaseEvent } from "./base.event";

export class AssessmentResponseEvent extends BaseEvent {
  constructor(store) {
    super(store);
    // this.registerEvent(
    //   "CREATE_ASSESSMENTRESPONSE",
    //   this.syncAssessmentResponses
    // );
    // this.registerEvent(
    //   "REMOVE_ASSESSMENTRESPONSE",
    //   this.syncAssessmentResponses
    // );
    // this.registerEvent(
    //   "UPDATE_ASSESSMENTRESPONSE",
    //   this.syncAssessmentResponses
    // );
  }

  // syncAssessmentResponses = ({ classId, createdBy }) => {
  //   this.dispatchAction(fetchAssessmentResponces(classId, createdBy));
  // };
}
